import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

// Busca um bloqueio de agenda individual em /agenda-blocks/{id}.
export function useAgendaBlock() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const fetchAgendaBlock = useCallback(
    (agendaBlockId) => {
      setLoading(true);
      return quarkusApi
        .get(`/agenda-blocks/${agendaBlockId}`, {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .catch((returnFromApi) => {
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.status === 401) {
            navigate('/expired-session');
          }
          throw returnFromApi;
        })
        .finally(() => setLoading(false));
    },
    [navigate],
  );

  return { fetchAgendaBlock, isLoading };
}
